import React from "react";
import { Link } from "react-router-dom";
import Rightimage from "../assets/images/Aboutus-img.svg";
import Leftimage from "../assets/images/Left-img.svg";
import Clients from "./Clients";

const FamilyTravelDetailLanding: React.FC = () => {
  return (
    <section className="relative bg-white text-gray-800 py-16">
      <div className="absolute right-0 top-2 sm:top-0 w-16 sm:w-auto">
        <img src={Rightimage} alt="Seamless Travel" className="object-fill" />
      </div>
      {/* Headline */}
    

      <div className="max-w-4xl mx-auto px-6 space-y-14">
        <section>
          <p className="text-lg leading-relaxed text-gray-700 font-poppins">
            You dream of quality time with your family—but planning a big
            international trip or cruise can feel like a second job. Conflicting
            schedules, uncertain itineraries, and the fear of wasting money on a
            trip that doesn’t wow everyone? That’s real.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-800 mb-3 font-akshar">
            The Journey
          </h2>
          <p className="text-lg leading-relaxed text-gray-700 font-poppins">
            Now imagine this: sailing into the Mediterranean as your kids race
            to spot dolphins off the balcony. Sharing fresh gelato on a cobbled
            street in Florence. Watching fireworks light up the sky from the
            deck of a Disney cruise. These aren’t just trips—they’re the moments
            that bring your family closer.
          </p>
        </section>
      </div>
      <div className="absolute left-0 bottom-2 sm:bottom-0 w-16 sm:w-36">
        <img src={Leftimage} alt="Seamless Travel" className="object-fill" />
      </div>
    </section>
  );
};

export default FamilyTravelDetailLanding;
